import { HttpClient }                                         from '@angular/common/http';
import { ModuleWithProviders, NgModule, Type }                from '@angular/core';
import { CsCultureProvider }                                  from '@cs/common/culture';
import { LoggerUtil }                                         from '@cs/core/utils';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';

import { ErrorRoutingModule }                  from './error-routing.module';
import { ErrorComponent }                      from './error.component';
import { IConfigService, CsTranslationLoader } from '@cs/performance-manager/shared';
import { ErrorConfigService }                  from './error-config.service';
import { CommonModule }                        from '@angular/common';
import {
	CsApplicationSettings,
	ComponentTranslationLoaderService,
	CsCommonPipesModule
}                                              from '@cs/common';

export function errorTranslationLoader(client: HttpClient,
																																							pmAppSettings: CsApplicationSettings,
																																							service: IConfigService,
																																							componentLoader: ComponentTranslationLoaderService) {
	return new CsTranslationLoader(`${pmAppSettings.translationLocation}/${service.moduleName}`,
																																client, componentLoader, pmAppSettings.deploymentDetails.buildDate);
}

@NgModule({
											imports     : [
												CommonModule,
												CsCommonPipesModule,
												TranslateModule.forChild({
																																						loader : {
																																							provide   : TranslateLoader,
																																							useFactory: errorTranslationLoader,
																																							deps      : [HttpClient, CsApplicationSettings,
																																																				ErrorConfigService,
																																																				ComponentTranslationLoaderService]
																																						},
																																						isolate: true
																																					}),
												ErrorRoutingModule
											],
											declarations: [ErrorComponent]
										})
export class PmErrorModule {

	static forRoot(moduleConfig: Type<ErrorConfigService>,
																appSetting: CsApplicationSettings): ModuleWithProviders<PmErrorModule> {
		return {
			ngModule : PmErrorModule,
			providers: [
				{
					provide : ErrorConfigService,
					useClass: moduleConfig
				},
				{
					provide : CsApplicationSettings,
					useValue: appSetting
				}
			]
		};
	}

	constructor(translate: TranslateService, culture: CsCultureProvider) {

		if (!translate) {
			LoggerUtil.warn('Translation service is not set-up');
			return;
		}

		// this language will be used as a fallback when a translation isn't found in the current language
		translate.setFallbackLang(culture.getDefaultCulture());

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translate.use(culture.getCulture());
	}
}
